import React, { useEffect, useState } from 'react';
interface CountdownTimerProps {
  className?: string;
  compact?: boolean;
}
export function CountdownTimer({
  className = '',
  compact = false
}: CountdownTimerProps) {
  // Mockup timer starting at 15:00:00
  const [timeLeft, setTimeLeft] = useState({
    hours: 0,
    minutes: 14,
    seconds: 59
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatNumber = (num: number) => num.toString().padStart(2, '0');
  if (compact) {
    return <div className={`font-mono font-bold text-lg tracking-wider ${className}`} data-id="element-275">
        {formatNumber(timeLeft.hours)}:{formatNumber(timeLeft.minutes)}:
        {formatNumber(timeLeft.seconds)}
      </div>;
  }
  return <div className={`flex items-center justify-center gap-2 md:gap-4 ${className}`} data-id="element-276">
      <div className="flex flex-col items-center" data-id="element-277">
        <div className="bg-[#1C1208] border border-[#2A1F0A] text-[#D4A843] font-mono text-3xl md:text-5xl font-bold p-3 md:p-4 rounded-lg min-w-[60px] md:min-w-[80px] text-center shadow-inner" data-id="element-278">
          {formatNumber(timeLeft.hours)}
        </div>
        <span className="text-[#C8B89A] text-xs md:text-sm mt-2 uppercase tracking-wider" data-id="element-279">
          Horas
        </span>
      </div>
      <div className="text-[#D4A843] text-3xl md:text-5xl font-bold pb-6 md:pb-8" data-id="element-280">
        :
      </div>
      <div className="flex flex-col items-center" data-id="element-281">
        <div className="bg-[#1C1208] border border-[#2A1F0A] text-[#D4A843] font-mono text-3xl md:text-5xl font-bold p-3 md:p-4 rounded-lg min-w-[60px] md:min-w-[80px] text-center shadow-inner" data-id="element-282">
          {formatNumber(timeLeft.minutes)}
        </div>
        <span className="text-[#C8B89A] text-xs md:text-sm mt-2 uppercase tracking-wider" data-id="element-283">
          Minutos
        </span>
      </div>
      <div className="text-[#D4A843] text-3xl md:text-5xl font-bold pb-6 md:pb-8" data-id="element-284">
        :
      </div>
      <div className="flex flex-col items-center" data-id="element-285">
        <div className="bg-[#1C1208] border border-[#2A1F0A] text-[#D4A843] font-mono text-3xl md:text-5xl font-bold p-3 md:p-4 rounded-lg min-w-[60px] md:min-w-[80px] text-center shadow-inner" data-id="element-286">
          {formatNumber(timeLeft.seconds)}
        </div>
        <span className="text-[#C8B89A] text-xs md:text-sm mt-2 uppercase tracking-wider" data-id="element-287">
          Segundos
        </span>
      </div>
    </div>;
}